import { render, staticRenderFns } from "./W3Channels.vue?vue&type=template&id=e73b8bfc&scoped=true"
import script from "./W3Channels.vue?vue&type=script&lang=js"
export * from "./W3Channels.vue?vue&type=script&lang=js"
import style0 from "./W3Channels.vue?vue&type=style&index=0&id=e73b8bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73b8bfc",
  null
  
)

export default component.exports